import React from 'react';
import { createContentPropTypes } from '../../../helpers/content';

const content = {
	buttonOk: 'OK',
	standingOrderDefinition: [
		'A ',
		<strong>standing order</strong>,
		' is a repeating payment you’ve set up on your own to pay other people or companies, or to transfer money between your own accounts.',
	],
	directDebitsDefinition: [
		'A ',
		<strong>Direct Debit</strong>,
		" is a repeating payment set up by the company you’re making payments to. You normally sign a mandate that gives them permission to take money from your account – like with a gym membership or phone bill. And you're protected under the Direct Debit guarantee scheme, so if money's ever debited in error, it's refunded straight away.",
	],
	DDSOInformation:
		"You can edit or cancel standing orders as and when you like. But if you want to change a Direct Debit, you’ll have to get in touch with the company you're paying to make the changes for you.",
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
